export default {
  global: 'global',
  audience: 'audience',
  activation: 'activation',
  campaign: 'campaign',
  funnel: 'funnel',
  contents: 'contents',
  pml: 'pml',
  llm: 'llm'
};
